export default __webpack_public_path__ + "static/media/banner.d1798854.jpg";